import axios from 'axios'
import history from '../history'
import {AUTH_TOKEN} from 'redux/constants/Auth'
import {notification} from 'antd';
import NotificationService from "../services/NotificationService";
import {APP_NOT_FOUND_PATH} from 'configs/AppConfig';
import {ACCOUNT_TRIAL_EXPIRED} from 'constants/ErrorCodeConstants';
import {ACCOUNT_CANCELED, ACCOUNT_OVERDUE, CANCELED, OVERDUE} from 'constants/SubscriptionConstants';

const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000
})

// Config
const ENTRY_ROUTE = '/auth/login'
const TOKEN_PAYLOAD_KEY = 'authorization'
const PUBLIC_REQUEST_KEY = 'public-request'

// API Request interceptor
service.interceptors.request.use(config => {
  const jwtToken = localStorage.getItem(AUTH_TOKEN)

  if (jwtToken) {
    config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken
  }

  if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
    const notificationParam = {
      message: '',
    };

    notificationParam.message = 'Authentication Fail';
    notificationParam.description = 'Please login again';
    notification.error(notificationParam);
    localStorage.clear();
    window.location.href = ENTRY_ROUTE;
  }

  return config
}, error => {
  // Do something with request error here
  notification.error({
    message: 'Error'
  })
  Promise.reject(error)
})

// API response interceptor
service.interceptors.response.use((response) => {


  return response.data
}, (error) => {

  let notificationParam = {
    message: ''
  }

  // Remove token and redirect
  if (error.response && error.response.status === 401) {
    notificationParam.message = 'Authentication Fail';
    notificationParam.description = 'Please login again';
    localStorage.clear();
    window.location.href = ENTRY_ROUTE;
  }

  if (error.response && error.response.status === 404) {
    notificationParam.message = 'Not Found';
    history.replace(APP_NOT_FOUND_PATH);
  }

  if (error.response && error.response.status === 422) {
    if (error.response.data.message) {
      notificationParam.message = error.response.data.message
    } else if (error.response.data.errors) {
      notificationParam.message = error.response.data.errors.join(" ")
    } else {
      notificationParam.message = "Invalid data"
    }
  }

  if (error.response && error.response.status === 500) {
    notificationParam.message = 'Internal Server Error'
  }

  if (error.response && error.response.status === 508) {
    notificationParam.message = 'Time Out'
  }

  if (error.response && error.response.status === 400) {
    if (error.response.data && error.response.data.error_code
      && (error.response.data.error_code === ACCOUNT_TRIAL_EXPIRED
        || error.response.data.error_code === OVERDUE
        || error.response.data.error_code === CANCELED
        || error.response.data.error_code === ACCOUNT_CANCELED
        || error.response.data.error_code === ACCOUNT_OVERDUE)) {
      // Force user to Billing
      history.push('/app/billing');
      return;
    }
    else {
      notificationParam.message = error.response.data.message
    }
  }

  if (error.response && error.response.data.errors) {
    for (const [key, value] of Object.entries(error.response.data.errors)) {
      NotificationService.error(`${key}: ${value}`)
    }
  } else {
    notification.error(notificationParam && notificationParam.message.length > 0 ? notificationParam : { message: 'An error ocurred', description: 'Please try it again' })
  }

  return Promise.reject(error);
});

export default service